import { tw } from '@/utils/tw';
import BaseFrontTheme from 'base/components/Front/theme';

const Front = tw.theme({
  extend: BaseFrontTheme,
  base: `relative gap-y-3 px-3 data-[opaque]:bg-gray-100 data-[opaque]:wings data-[opaque]:wings-gray-100`,
});

export default Front;
